import { NgClass } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { first, Observable, Subject } from 'rxjs';

import { ClickActionEvent } from '@bn/primitives';
import { SanitizeHtmlPipe } from '@bn/shared/core/pipes/sanitize-html.pipe';

import { ButtonComponent } from '../../../button/button.component';
import { ModalState } from '../../../dialog/models';
import { FontawesomeGradientDirective } from '../../../directives/fontawesome-gradient.directive';
import { SwitchComponent } from '../../../switch/switch.component';

@Component({
  selector: 'bn-web-ui-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  imports: [NgClass, FaIconComponent, FontawesomeGradientDirective, SwitchComponent, FormsModule, ButtonComponent, SanitizeHtmlPipe],
})
export class ConfirmationDialogComponent {
  #dialogRef: BsModalRef<ConfirmationDialogComponent> = inject(BsModalRef);
  #onAction = new Subject<ClickActionEvent>();

  data?: ModalState;
  isLoading = signal(false);
  showDialog = false; // dialog stays open after submit

  constructor() {
    this.#dialogRef.onHide?.pipe(first()).subscribe((event) => {
      if (event === 'backdrop-click' || event === 'esc') {
        this.#onAction.next({
          ...this.data?.event,
          action: 'cancel',
        });
      }
    });
  }

  public onSubmit(): void {
    // NOTE: prevent double click
    if (this.isLoading()) return;

    this.isLoading.set(true);
    // NOTE: just pass parent event, and replace action to delete
    this.#onAction.next({
      ...this.data?.event,
      data: this.data,
      action: 'confirm',
    });

    if (!this.showDialog) this.#dialogRef.hide();
  }

  public onCloseDialog(): void {
    this.#onAction.next({
      ...this.data?.event,
      data: this.data,
      action: 'cancel',
    });
  }

  public getOnAction$(): Observable<ClickActionEvent> {
    return this.#onAction.asObservable();
  }

  setLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }
}
